<div class="error">
  <div class="container-floud">
      <div class="col-xs-12 ground-color text-center">
          <div class="container-error-404">
              <div class="clip"><div class="shadow"><span class="digit thirdDigit"></span></div></div>
              <div class="clip"><div class="shadow"><span class="digit secondDigit"></span></div></div>
              <div class="clip"><div class="shadow"><span class="digit firstDigit"></span></div></div>
              <div class="msg">OH!<span class="triangle"></span></div>
          </div>
          <h2 class="h1">¡Lo siento! Página no encontrada</h2>
          <a routerLink="/" class="btn btn-outline-secondary mb-4">ir al inicio</a>
      </div>
  </div>
</div>
